import { Pipe, PipeTransform } from '@angular/core';
import { LssEntityStatus } from '../store/deployment.datamodel';

/**
 * Pipe to display the label of a deployment status.
 */
@Pipe({
    name: 'statusLabel',
    standalone: false
})
export class StatusLabelPipe implements PipeTransform {
  transformer = {
    [LssEntityStatus.TO_BE_DEPLOYED]: 'Deploy' ,
    [LssEntityStatus.TO_BE_UNDEPLOYED]:'Undeploy',
    [LssEntityStatus.TO_BE_EXCLUDED]: 'Exclude',
    [LssEntityStatus.TO_BE_UNEXCLUDED]: 'Unexclude',
    [LssEntityStatus.DEPLOYED]: '',
    [LssEntityStatus.EXCLUDED]: '',
    [LssEntityStatus.UNDEPLOYED]: '',
    [LssEntityStatus.TO_REMOVE_OVERRIDE]: '',
    [LssEntityStatus.OVERRIDE]: '',
  };
  transform(status: LssEntityStatus): string {
    return this.transformer[status];
  }
}
